import { useIntercomInstance } from './useIntercomInstance';

export const useIsHelpChatEnabled = () => {
  return useIntercomInstance() !== undefined;
};
